var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsNone24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9989 15.7511L18.9993 10.7511C18.9996 7.68115 17.3698 5.11101 14.4998 4.43078L14.4999 3.75078C14.4999 2.92078 13.83 2.25072 13 2.25066C12.17 2.25059 11.4999 2.92053 11.4999 3.75053L11.4998 4.43053C8.63977 5.1103 6.99956 7.67016 6.9993 10.7502L6.99889 15.7502L4.99873 17.75L4.99865 18.75L20.9986 18.7513L20.9987 17.7513L18.9989 15.7511ZM12.9984 21.7507C14.0984 21.7507 14.9985 20.8508 14.9986 19.7508L10.9986 19.7505C10.9985 20.8505 11.8984 21.7506 12.9984 21.7507ZM8.99881 16.7503L16.9988 16.751L16.9993 10.751C16.9995 8.27098 15.4897 6.25086 12.9997 6.25066C10.5097 6.25045 8.99951 8.27033 8.9993 10.7503L8.99881 16.7503Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsNone24Px);
export default __webpack_public_path__ + "static/media/notifications_none_24px.a7886920554f4352966590f799181659.svg";
export { ForwardRef as ReactComponent };